import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useCategoryDropdown({ enabled = false } = {}) {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  const fetchCategories = async () => {
    try {
      const res = await privateFetch.get('/v1/admin/podcast/supporting/categories', {
        params: { mode: 'dropdown' },
      });
      return res.data;
    } catch (err) {
      console.error('Category fetch failed:', err?.response?.data || err.message);
      throw err;
    }
  };

  return useQuery(['podcast-category-dropdown'], fetchCategories, {
    enabled,
    keepPreviousData: true,
  });
}

export default useCategoryDropdown;
